import { mutations } from './mutations'
import { actions } from './actions'

export const plp = {
  namespaced: true,
  state: {
    products: [],
    wcag: {
      focusedTileId: null,
    },
    seo: {
      title: '',
      subtitle: '',
      totalNumberOfProducts: '',
      seoText: '',
    },
  },
  getters: {
    products: (state) => state.products,
    wcagFocusedTileId: (state) => state.wcag.focusedTileId,
    getSeoConf: (state) => state.seo,
  },
  mutations,
  actions,
}
